<div class="card">
  <p-toast />
  <div class="card" style="display: flex; justify-content:space-between; padding:0%; align-items:center; border: none; background-color: transparent;">
      <div><h4><strong style="font-size: large; margin-left:10px" style="color: black;">Vendor Query List</strong></h4></div>
      <div class="grid">
      <p-button label="Report"  icon="pi pi-download" (click)="downloadExcel()"/>
      </div>
  </div>
    <hr>

      <p-table  [value]="vendorList" styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" [rows]="10"
      [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '50rem' }"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"  [rowsPerPageOptions]="[10, 20,30,50,100]">
      <ng-template pTemplate="header">
          <tr>
              <!-- <th class="bg-orange"></th> -->
              <th pSortableColumn="business_name" class="bg-orange">Name <p-sortIcon field="business_name"></p-sortIcon></th>
              <th pSortableColumn="plant" class="bg-orange">Plant <p-sortIcon field="plant"></p-sortIcon></th>
              <th pSortableColumn="approval_name" class="bg-orange">Approval<p-sortIcon field="approval_name"></p-sortIcon></th>
              <th pSortableColumn="query_date" class="bg-orange">Query Date<p-sortIcon field="query_date"></p-sortIcon></th>
              <th pSortableColumn="vendor_query_remark" class="bg-orange">Vendor Query<p-sortIcon field="vendor_query_remark"></p-sortIcon></th>
              <th pSortableColumn="status" class="bg-orange">Status<p-sortIcon field="status"></p-sortIcon></th>
          </tr>
          <tr>
              <!-- <th class="bg-orange"></th> -->
              <th class="bg-orange">
                  <p-columnFilter
                      type="text"
                      field="business_name"
                      placeholder="Search"
                      ariaLabel="Filter Name" />
              </th>
              <th class="bg-orange">
                  <p-columnFilter
                      type="text"
                      field="plant"
                      placeholder="Search"
                      ariaLabel="Filter Plant" />
              </th>
              <th class="bg-orange">
                  <p-columnFilter
                      type="text"
                      field="approval_name"
                      placeholder="Search"
                      ariaLabel="Filter" />
              </th>
              <th class="bg-orange">
                  <p-columnFilter
                      type="text"
                      field="query_date"
                      placeholder="Search"
                      ariaLabel="Filter" />
              </th>
              <th class="bg-orange">
                  <p-columnFilter
                      type="text"
                      field="vendor_query_remark"
                      placeholder="Search"
                      ariaLabel="Filter" />
              </th>
              <th class="bg-orange">
                  <p-columnFilter
                      type="text"
                      field="status"
                      placeholder="Search"
                      ariaLabel="Filter" />
              </th>
            </tr>
      </ng-template>
      <ng-template pTemplate="body" let-vendor>
          <tr>
              <!-- <td>
                  <button pButton type="button" icon="pi pi-eye" (click)="goToVendorDetails(vendor.business_name,vendor.status)" class="p-button-rounded" pTooltip="View Details"></button>
              </td> -->
              <td><strong>{{ vendor.business_name }}</strong></td>
              <td><strong>{{ vendor.plant }}</strong></td>
              <td><strong>{{ vendor.approval_name }}</strong></td>
              <td><strong>{{ vendor.query_date | date:'dd/MM/yyyy' }}</strong></td>
              <td class="table-cell-wrap"><strong>{{ vendor.vendor_query_remark }}</strong></td>
              <td><strong>{{ vendor.status }}</strong></td>
          </tr>
      </ng-template>
  </p-table>
</div>
